import styled from 'styled-components';

import { clampLines } from 'styles/mixins';

export type Size = 'medium' | 'large';

interface ProductNameProps {
  size: Size;
}

export const ProductName = styled.p<ProductNameProps>`
  font-size: ${(props) => (props.size === 'medium' ? '12px' : '18px')};
  font-weight: bold;

  margin-bottom: 4px;

  ${clampLines(1)}
`;

export const ConceptLabel = styled.p<ProductNameProps>`
  font-size: ${(props) => (props.size === 'medium' ? '11px' : '15px')};
  font-weight: bold;
  text-transform: uppercase;
  line-height: 1.2;
  min-height: 1.2em;

  margin-bottom: 4px;

  ${clampLines(1)}
`;
